import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_LODESTAR_QUESTIONS_ACTION_TYPE } from '../actions';

const initialState = {
  questions: [],
  answers: {},
};

const loanLodeStarQuestionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_LODESTAR_QUESTIONS_ACTION_TYPE.GET_LODESTAR_QUESTIONS:
        draft.questions = payload?.questions || initialState.questions;
        draft.answers = payload?.answers || initialState.answers;
        break;

      case LOAN_LODESTAR_QUESTIONS_ACTION_TYPE.EDIT_LODESTAR_QUESTIONS:
        draft.answers = payload?.answers || initialState.answers;
        break;

      case LOAN_LODESTAR_QUESTIONS_ACTION_TYPE.RESET_LODESTAR_QUESTIONS:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanLodeStarQuestionsReducer;
